import React, { useEffect, useState } from 'react';
import axios from 'axios';

const SessionAttendance = () => {
  const [sessions, setSessions] = useState([]);
  const [selectedSession, setSelectedSession] = useState(null);
  const [attendanceList, setAttendanceList] = useState([]);
  const teacherId = localStorage.getItem('userId');

  useEffect(() => {
    if (teacherId) {
      axios
        .get(`http://localhost:8081/api/teacher/sessions/${teacherId}`)
        .then((res) => setSessions(res.data.sessions))
        .catch((err) => console.error('Error fetching sessions:', err));
    }
  }, [teacherId]);

  const fetchAttendance = (session) => {
    setSelectedSession(session);
    axios
      .get(`http://localhost:8081/api/teacher/session-attendance/${session.session_id}`)
      .then((res) => setAttendanceList(res.data.attendance))
      .catch((err) => console.error('Error fetching attendance:', err));
  };

  const goBack = () => {
    setSelectedSession(null);
    setAttendanceList([]);
  };

  return (
    <div className="session-container">
      {!selectedSession ? (
        <>
          <h2 className="title">📚 Class Sessions</h2>
          <div className="sessions-list">
            {sessions.map((session) => (
              <div key={session.session_id} className="session-card">
                <h3>{session.subject_name}</h3>
                <p><strong>Date:</strong> {session.date}</p>
                <p><strong>Duration:</strong> 60 mins</p>
                <button onClick={() => fetchAttendance(session)}>View Attendance</button>
              </div>
            ))}
          </div>
        </>
      ) : (
        <>
          <button onClick={goBack} className="back-btn">← Back to Sessions</button>
          <h2 className="title">Attendance for {selectedSession.subject_name}</h2>
          <p><strong>Date:</strong> {selectedSession.date}</p>
          <p><strong>Duration:</strong> {selectedSession.duration} mins</p>

          <table className="attendance-table">
            <thead>
              <tr>
                <th>Student Name</th>
                <th>Date</th>
                <th>Status</th>
              </tr>
            </thead>
            <tbody>
              {attendanceList.map((entry, index) => (
                <tr key={index}>
                  <td>{entry.student_name}</td>
                  <td>{entry.date}</td>
                  <td>{entry.status}</td>
                </tr>
              ))}
              {attendanceList.length === 0 && (
                <tr>
                  <td colSpan="3">No records found.</td>
                </tr>
              )}
            </tbody>
          </table>
        </>
      )}
    </div>
  );
};

export default SessionAttendance;
